
import axios from 'axios';

// app config
import AppConfig from 'Constants/AppConfig';
import AuthHeader from 'Constants/AuthHeader';

import { NotificationManager } from 'react-notifications';
import {
   SCASSESSMENT_ACTION, 
   ALL_SCASSESSMENT,
   CHECK_SCASSESSMENT_DONE,
   ADD_SCASSESSMENT_SUCCESS,
   ADD_SCASSESSMENT_FAILURE,
   FETCH_SCASSESSMENT,
   EDIT_SCASSESSMENT_SUCCESS,
   EDIT_SCASSESSMENT_FAILURE,
   DELETE_SCASSESSMENT_SUCCESS,
   DELETE_SCASSESSMENT_FAILURE
} from 'Actions/types';

/**
 * Redux Action To Sigin User With Firebase
 */
export const allSCAssessment = () =>{    
    
    return (dispatch) => { 
        dispatch({ type: SCASSESSMENT_ACTION });
        axios.get(AppConfig.apiurl+'/api/fetchstrengthcondition', { headers: AuthHeader.header })         
        .then(response => {             
            const allresponse=response.data.data;
            dispatch({ type: ALL_SCASSESSMENT, payload: allresponse });
        });
    }    

}

export const checkSCAssessment = (studentid,date,quarter) => async (dispatch) => {
	
        var payload={
            "studentid":studentid,
            "adate":date,
            "quarter":quarter
        }
    
        dispatch({ type: SCASSESSMENT_ACTION});
        return axios.post(AppConfig.apiurl+'/api/checkforscdata', payload, { headers: AuthHeader.header })
            .then( response => {   
                var resdata=response.data;				
                dispatch({ type: CHECK_SCASSESSMENT_DONE}); 
                return Promise.resolve(resdata);
                
            })
            .catch( error => { 
                const errormsg=error.message
                NotificationManager.error(errormsg);
            });

    
}

export const addSCAssessment = (mskstate, rmtest, aerobictest, lowerbodytest, upperbody, acceleration, coreendurance) => async (dispatch) => {
    if(rmtest==true){
        var rmclean_value= mskstate.target.rmclean_value.value;
        var rmcleanestimate_value= mskstate.target.rmcleanestimate_value.value;
        var rmclean_remarks=mskstate.target.rmclean_remarks.value;
        var rmsquat_value=mskstate.target.rmsquat_value.value;
        var rmsquatestimate_value= mskstate.target.rmsquatestimate_value.value;
        var rmsquat_remarks=mskstate.target.rmsquat_remarks.value;
        var rmpress_value=mskstate.target.rmpress_value.value;
        var rmpressestimate_value= mskstate.target.rmpressestimate_value.value;
        var rmpress_remarks=mskstate.target.rmpress_remarks.value;
        var rmcleanestimate_rm=mskstate.target.rmcleanestimate_rm.value;
        var rmsquatestimate_rm=mskstate.target.rmsquatestimate_rm.value;
        var rmpressestimate_rm=mskstate.target.rmpressestimate_rm.value;
        var onermtestcheck=1;
    }else{
        var rmclean_value= '';
        var rmcleanestimate_value='';
        var rmclean_remarks='';
        var rmsquat_value='';
        var rmsquatestimate_value='';
        var rmsquat_remarks='';
        var rmpress_value='';
        var rmpressestimate_value='';
        var rmpress_remarks='';
        var onermtestcheck='0';
        var rmcleanestimate_rm="";
        var rmsquatestimate_rm="";
        var rmpressestimate_rm="";
    }

    if(aerobictest==true){
        var aerobicfitness_time=mskstate.target.aerobicfitness_time.value;
        var aerobicfitness_remarks=mskstate.target.aerobicfitness_remarks.value;
        var aerobicfitness_vo=mskstate.target.aerobicfitness_vo.value;
        var aerobicfitnesscheck=1;
    }else{
        var aerobicfitness_time='';
        var aerobicfitness_vo=0;
        var aerobicfitness_remarks='';
        var aerobicfitnesscheck=0;
    }

    if(lowerbodytest==true){
        var lowerboay_trial1=mskstate.target.lowerboay_trial1.value;
        var lowerboay_trial2=mskstate.target.lowerboay_trial2.value;
        var lowerboay_trial3=mskstate.target.lowerboay_trial3.value;
        var lowerboay_result=mskstate.target.lowerboay_result.value;
        var lowerboay_remarks=mskstate.target.lowerboay_remarks.value;
        var lowerbodypowercheck=1;
    }else{
        var lowerboay_trial1='';
        var lowerboay_trial2='';
        var lowerboay_trial3='';
        var lowerboay_remarks='';
        var lowerboay_result='';
        var lowerbodypowercheck=0;
    }

    if(upperbody==true){
        var upperbodystrength_score=mskstate.target.upperbodystrength_score.value;
        var upperbodystrength_remarks=mskstate.target.upperbodystrength_remarks.value;
        var upperbodystrengthcheck=1;
    }else{
        var upperbodystrength_score='';
        var upperbodystrength_remarks='';
        var upperbodystrengthcheck=0;
    }

    if(acceleration==true){
        var acceleration_trial1=mskstate.target.acceleration_trial1.value;
        var acceleration_trial2=mskstate.target.acceleration_trial2.value;
        var acceleration_trial3=mskstate.target.acceleration_trial3.value;
        var acceleration_result=mskstate.target.acceleration_result.value;
        var acceleration_remarks=mskstate.target.acceleration_remarks.value;
        var accelerationspeedcheck=1;
    }else{
        var acceleration_trial1='';
        var acceleration_trial2='';
        var acceleration_trial3='';
        var acceleration_remarks='';
        var acceleration_result='';
        var accelerationspeedcheck=0;
    }

    if(coreendurance==true){
        var coreendurance_score=mskstate.target.coreendurance_score.value;
        var coreendurance_remarks=mskstate.target.coreendurance_remarks.value;
        var coreendurancecheck=1;
    }else{
        var coreendurance_score='';
        var coreendurance_remarks='';
        var coreendurancecheck=0;
    }

    var payload={
        "userid":mskstate.target.student.value,
        "quarter":mskstate.target.quarter.value,
        "assdate":mskstate.target.seldate.value,

        "scassessor":mskstate.target.scassessor.value,
        "mskskill":mskstate.target.mskskill.value,
        "medicalhistory":mskstate.target.medicalhistory.value,
        "medicalrecord":mskstate.target.medicalrecord.value,
        "allergies":mskstate.target.allergies.value,
        "injuryhistory":mskstate.target.injuryhistory.value,
        
        // Strength & condition

        "scheight" : mskstate.target.scheight.value,
        "scweight" : mskstate.target.scweight.value,
        "scbmi" : mskstate.target.scbmi.value,
        "scwaist" : mskstate.target.scwaist.value,
        "schip" : mskstate.target.schip.value,
        "scwhratio" : mskstate.target.scwhratio.value,
        "scuaright" : mskstate.target.scuaright.value,
        "scualeft" : mskstate.target.scualeft.value,
        "scmidthighright" : mskstate.target.scmidthighright.value,
        "scmidthighleft" : mskstate.target.scmidthighleft.value,
        "scmidcalfright" : mskstate.target.scmidcalfright.value,
        "scmidcalfleft" : mskstate.target.scmidcalfleft.value,
        "sc_impression" : mskstate.target.sc_impression.value,
        "sc_approach" : mskstate.target.sc_approach.value,

        "deepsquat_rawscore" : mskstate.target.deepsquat_rawscore.value,
        "deepsquat_finalscore" : mskstate.target.deepsquat_finalscore.value,
        "deepsquat_comments" : mskstate.target.deepsquat_comments.value,
        "hurdlestep_r_rawscore" : mskstate.target.hurdlestep_r_rawscore.value,
        "hurdlestep_r_finalscore" : mskstate.target.hurdlestep_r_finalscore.value,
        "hurdlestep_r_comments" : mskstate.target.hurdlestep_r_comments.value,
        "hurdlestep_l_rawscore" : mskstate.target.hurdlestep_l_rawscore.value,
        "hurdlestep_l_comments" : mskstate.target.hurdlestep_l_comments.value,
        "inlinelunge_r_rawscore" : mskstate.target.inlinelunge_r_rawscore.value,
        "inlinelunge_r_finalscore" : mskstate.target.inlinelunge_r_finalscore.value,
        "inlinelunge_r_comments" : mskstate.target.inlinelunge_r_comments.value,
        "inlinelunge_l_rawscore" : mskstate.target.inlinelunge_l_rawscore.value,
        "inlinelunge_l_comments" : mskstate.target.inlinelunge_l_comments.value,
        "shouldermobility_r_rawscore" : mskstate.target.shouldermobility_r_rawscore.value,
        "shouldermobility_r_finalscore" : mskstate.target.shouldermobility_r_finalscore.value,
        "shouldermobility_r_comments" : mskstate.target.shouldermobility_r_comments.value,
        "shouldermobility_l_rawscore" : mskstate.target.shouldermobility_l_rawscore.value,
        "shouldermobility_l_comments" : mskstate.target.shouldermobility_l_comments.value,
        "shoulderclearance_r_comments" : mskstate.target.shoulderclearance_r_comments.value,
        "activestraightlegraise_r_rawscore" : mskstate.target.activestraightlegraise_r_rawscore.value,
        "activestraightlegraise_r_finalscore" : mskstate.target.activestraightlegraise_r_finalscore.value,
        "activestraightlegraise_r_comments" : mskstate.target.activestraightlegraise_r_comments.value,
        "activestraightlegraise_l_rawscore" : mskstate.target.activestraightlegraise_l_rawscore.value,
        "activestraightlegraise_l_comments" : mskstate.target.activestraightlegraise_l_comments.value,
        "trunkstabilitypushup_rawscore" : mskstate.target.trunkstabilitypushup_rawscore.value,
        "trunkstabilitypushup_finalscore" : mskstate.target.trunkstabilitypushup_finalscore.value,
        "trunkstabilitypushup_comments" : mskstate.target.trunkstabilitypushup_comments.value,
        "pressupclearing_comments" : mskstate.target.pressupclearing_comments.value,
        "rotarystability_r_rawscore" : mskstate.target.rotarystability_r_rawscore.value,
        "rotarystability_r_finalscore" : mskstate.target.rotarystability_r_finalscore.value,
        "rotarystability_r_comments" : mskstate.target.rotarystability_r_comments.value,
        "rotarystability_l_rawscore" : mskstate.target.rotarystability_l_rawscore.value,
        "rotarystability_l_comments" : mskstate.target.rotarystability_l_comments.value,
        "posteriorrocking_comments" : mskstate.target.posteriorrocking_comments.value,
        "totalscore_finalscore" : mskstate.target.totalscore_finalscore.value,
        "functionalmovement_impression" : mskstate.target.functionalmovement_impression.value,
        "functionalmovement_approach" : mskstate.target.functionalmovement_approach.value,
        "boxjump_score" : mskstate.target.boxjump_score.value,
        "boxjump_remarks" : mskstate.target.boxjump_remarks.value,
        "singlerighthopright_score" : mskstate.target.singlerighthopright_score.value,
        "singlerighthopright_remarks" : mskstate.target.singlerighthopright_remarks.value,
        "singlerighthopleft_score" : mskstate.target.singlerighthopleft_score.value,
        "singlerighthopleft_remarks" : mskstate.target.singlerighthopleft_remarks.value,
        "deadlift_score" : mskstate.target.deadlift_score.value,
        "deadlift_remarks" : mskstate.target.deadlift_remarks.value,
        "pullup_score" : mskstate.target.pullup_score.value,
        "pullup_remarks" : mskstate.target.pullup_remarks.value,
        "pushup_score" : mskstate.target.pushup_score.value,
        "pushup_remarks" : mskstate.target.pushup_remarks.value,
        "plank_score" : mskstate.target.plank_score.value,
        "plank_remarks" : mskstate.target.plank_remarks.value,
        "medicineball_score" : mskstate.target.medicineball_score.value,
        "medicineball_remarks" : mskstate.target.medicineball_remarks.value,
        "movementpattern_impression" : mskstate.target.movementpattern_impression.value,
        "movementpattern_approach" : mskstate.target.movementpattern_approach.value,

        "clubhd_box" : mskstate.target.clubhd_box.value,
        "drivercarry_distance" : mskstate.target.drivercarry_distance.value,
        "clubhd_impression" : mskstate.target.clubhd_impression.value,
        "clubhd_approach" : mskstate.target.clubhd_approach.value,
        "clubhdshrtgoal1" : mskstate.target.clubhdshrtgoal1.value,
        "clubhdlonggoal1" : mskstate.target.clubhdlonggoal1.value,

        "onermtestcheck" : onermtestcheck,
        "aerobicfitnesscheck" : aerobicfitnesscheck,
        "lowerbodypowercheck" : lowerbodypowercheck,
        "upperbodystrengthcheck" : upperbodystrengthcheck,
        "accelerationspeedcheck" : accelerationspeedcheck,
        "coreendurancecheck" : coreendurancecheck,


        "rmclean_value" : rmclean_value,
        "rmclean_remarks" : rmclean_remarks,
        "rmsquat_value" : rmsquat_value,
        "rmsquat_remarks" : rmsquat_remarks,
        "rmpress_value" : rmpress_value,
        "rmpress_remarks" : rmpress_remarks,
        "rmcleanestimate_value":rmcleanestimate_value,
        "rmsquatestimate_value":rmsquatestimate_value,
        "rmpressestimate_value":rmpressestimate_value,
        "rmcleanestimate_rm":rmcleanestimate_rm,
        "rmsquatestimate_rm":rmsquatestimate_rm,
        "rmpressestimate_rm":rmpressestimate_rm,
        "aerobicfitness_time" : aerobicfitness_time,
        "aerobicfitness_vo" : aerobicfitness_vo,
        "aerobicfitness_remarks" : aerobicfitness_remarks,
        "lowerboay_trial1" : lowerboay_trial1,
        "lowerboay_trial2" : lowerboay_trial2,
        "lowerboay_trial3" : lowerboay_trial3,
        "lowerboay_result" : lowerboay_result,
        "lowerboay_remarks" : lowerboay_remarks,
        "upperbodystrength_score" : upperbodystrength_score,
        "upperbodystrength_remarks" : upperbodystrength_remarks,
        "acceleration_trial1" : acceleration_trial1,
        "acceleration_trial2" : acceleration_trial2,
        "acceleration_trial3" : acceleration_trial3,
        "acceleration_remarks" : acceleration_remarks,
        "acceleration_result": acceleration_result,
        "coreendurance_score" : coreendurance_score,
        "coreendurance_remarks" : coreendurance_remarks
    }
    
    dispatch({ type: SCASSESSMENT_ACTION});
    return axios.post(AppConfig.apiurl+'/api/createscassessment', payload, { headers: AuthHeader.header })
        .then( response => {       
            if(response.status==200){ 
                var resdata=response.data;
                if(resdata.status===1){
                    allSCAssessment()(dispatch);
                    NotificationManager.success(resdata.message);               
                    dispatch({ type: ADD_SCASSESSMENT_SUCCESS});
                }else{
                    NotificationManager.error(resdata.message); 
                    dispatch({ type: ADD_SCASSESSMENT_FAILURE});			   
                }	
                    
            }else{
                NotificationManager.error('SC Assessment not added');	
                dispatch({ type: ADD_SCASSESSMENT_FAILURE});	  
            }  
            
            return Promise.resolve(resdata);
            
        })
        .catch( error => { 
            const errormsg=error.message
            NotificationManager.error(errormsg);
            dispatch({ type: ADD_SCASSESSMENT_FAILURE});
        });		

}

export const fetchSCAssessment = (rowdata) => async (dispatch) => {
	
	var payload={
		"studentid":rowdata.user_id,
		"assessment_date":rowdata.assessment_date
	}
	
	  dispatch({ type: SCASSESSMENT_ACTION});
		 return axios.post(AppConfig.apiurl+'/api/createEditSCAssessment', payload, { headers: AuthHeader.header })
			.then( response => {   
				var resdata=response.data;	
				var resvalue=resdata.data;			
				dispatch({ type: FETCH_SCASSESSMENT, payload:resvalue[0]}); 
				return Promise.resolve(resdata);
				
			})
			.catch( error => { 
				const errormsg=error.message
				NotificationManager.error(errormsg);
			});

	
}


export const editSCAssessment = (mskstate, rmtest, aerobictest, lowerbodytest, upperbody, acceleration, coreendurance) => async (dispatch) => {
	
	if(rmtest==true){
		var rmclean_value= mskstate.target.rmclean_value.value;
		var rmcleanestimate_value= mskstate.target.rmcleanestimate_value.value;
		var rmclean_remarks=mskstate.target.rmclean_remarks.value;
		var rmsquat_value=mskstate.target.rmsquat_value.value;
		var rmsquatestimate_value= mskstate.target.rmsquatestimate_value.value;
		var rmsquat_remarks=mskstate.target.rmsquat_remarks.value;
		var rmpress_value=mskstate.target.rmpress_value.value;
		var rmpressestimate_value= mskstate.target.rmpressestimate_value.value;
		var rmpress_remarks=mskstate.target.rmpress_remarks.value;
		var rmcleanestimate_rm=mskstate.target.rmcleanestimate_rm.value;
		var rmsquatestimate_rm=mskstate.target.rmsquatestimate_rm.value;
		var rmpressestimate_rm=mskstate.target.rmpressestimate_rm.value;
		var onermtestcheck=1;
	}else{
		var rmclean_value= '';
		var rmcleanestimate_value='';
		var rmclean_remarks='';
		var rmsquat_value='';
		var rmsquatestimate_value='';
		var rmsquat_remarks='';
		var rmpress_value='';
		var rmpressestimate_value='';
		var rmpress_remarks='';
		var onermtestcheck='0';
		var rmcleanestimate_rm="";
		var rmsquatestimate_rm="";
		var rmpressestimate_rm="";
	}

	if(aerobictest==true){
		var aerobicfitness_time=mskstate.target.aerobicfitness_time.value;
		var aerobicfitness_remarks=mskstate.target.aerobicfitness_remarks.value;
		var aerobicfitness_vo=mskstate.target.aerobicfitness_vo.value;
		var aerobicfitnesscheck=1;
	}else{
		var aerobicfitness_time='';
		var aerobicfitness_vo=0;
		var aerobicfitness_remarks='';
		var aerobicfitnesscheck=0;
	}

	if(lowerbodytest==true){
		var lowerboay_trial1=mskstate.target.lowerboay_trial1.value;
		var lowerboay_trial2=mskstate.target.lowerboay_trial2.value;
		var lowerboay_trial3=mskstate.target.lowerboay_trial3.value;
		var lowerboay_result=mskstate.target.lowerboay_result.value;
		var lowerboay_remarks=mskstate.target.lowerboay_remarks.value;
		var lowerbodypowercheck=1;
	}else{
		var lowerboay_trial1='';
		var lowerboay_trial2='';
		var lowerboay_trial3='';
		var lowerboay_remarks='';
		var lowerboay_result='';
		var lowerbodypowercheck=0;
	}

	if(upperbody==true){
		var upperbodystrength_score=mskstate.target.upperbodystrength_score.value;
		var upperbodystrength_remarks=mskstate.target.upperbodystrength_remarks.value;
		var upperbodystrengthcheck=1;
	}else{
		var upperbodystrength_score='';
		var upperbodystrength_remarks='';
		var upperbodystrengthcheck=0;
	}

	if(acceleration==true){
		var acceleration_trial1=mskstate.target.acceleration_trial1.value;
		var acceleration_trial2=mskstate.target.acceleration_trial2.value;
		var acceleration_trial3=mskstate.target.acceleration_trial3.value;
		var acceleration_result=mskstate.target.acceleration_result.value;
		var acceleration_remarks=mskstate.target.acceleration_remarks.value;
		var accelerationspeedcheck=1;
	}else{
		var acceleration_trial1='';
		var acceleration_trial2='';
		var acceleration_trial3='';
		var acceleration_remarks='';
		var acceleration_result='';
		var accelerationspeedcheck=0;
	}

	if(coreendurance==true){
		var coreendurance_score=mskstate.target.coreendurance_score.value;
		var coreendurance_remarks=mskstate.target.coreendurance_remarks.value;
		var coreendurancecheck=1;
	}else{
		var coreendurance_score='';
		var coreendurance_remarks='';
		var coreendurancecheck=0;
	}
		var payload={

			"userid":mskstate.target.userid.value,
            "pa_id":mskstate.target.pa_id.value,
			"assdate":mskstate.target.assdate.value,
			"quarter":mskstate.target.quarter.value,
			"scassessor":mskstate.target.scassessor.value,
			"mskskill":mskstate.target.mskskill.value,
			"medicalhistory":mskstate.target.medicalhistory.value,
			"medicalrecord":mskstate.target.medicalrecord.value,
			"allergies":mskstate.target.allergies.value,
            "injuryhistory":mskstate.target.injuryhistory.value,
			// Strength & condition

			"scheight" : mskstate.target.scheight.value,
			"scweight" : mskstate.target.scweight.value,
			"scbmi" : mskstate.target.scbmi.value,
			"scwaist" : mskstate.target.scwaist.value,
			"schip" : mskstate.target.schip.value,
			"scwhratio" : mskstate.target.scwhratio.value,
			"scuaright" : mskstate.target.scuaright.value,
			"scualeft" : mskstate.target.scualeft.value,
			"scmidthighright" : mskstate.target.scmidthighright.value,
			"scmidthighleft" : mskstate.target.scmidthighleft.value,
			"scmidcalfright" : mskstate.target.scmidcalfright.value,
			"scmidcalfleft" : mskstate.target.scmidcalfleft.value,
			"sc_impression" : mskstate.target.sc_impression.value,
			"sc_approach" : mskstate.target.sc_approach.value,

			"deepsquat_rawscore" : mskstate.target.deepsquat_rawscore.value,
			"deepsquat_finalscore" : mskstate.target.deepsquat_finalscore.value,
			"deepsquat_comments" : mskstate.target.deepsquat_comments.value,
			"hurdlestep_r_rawscore" : mskstate.target.hurdlestep_r_rawscore.value,
			"hurdlestep_r_finalscore" : mskstate.target.hurdlestep_r_finalscore.value,
			"hurdlestep_r_comments" : mskstate.target.hurdlestep_r_comments.value,
			"hurdlestep_l_rawscore" : mskstate.target.hurdlestep_l_rawscore.value,
			"hurdlestep_l_comments" : mskstate.target.hurdlestep_l_comments.value,
			"inlinelunge_r_rawscore" : mskstate.target.inlinelunge_r_rawscore.value,
			"inlinelunge_r_finalscore" : mskstate.target.inlinelunge_r_finalscore.value,
			"inlinelunge_r_comments" : mskstate.target.inlinelunge_r_comments.value,
			"inlinelunge_l_rawscore" : mskstate.target.inlinelunge_l_rawscore.value,
			"inlinelunge_l_comments" : mskstate.target.inlinelunge_l_comments.value,
			"shouldermobility_r_rawscore" : mskstate.target.shouldermobility_r_rawscore.value,
			"shouldermobility_r_finalscore" : mskstate.target.shouldermobility_r_finalscore.value,
			"shouldermobility_r_comments" : mskstate.target.shouldermobility_r_comments.value,
			"shouldermobility_l_rawscore" : mskstate.target.shouldermobility_l_rawscore.value,
			"shouldermobility_l_comments" : mskstate.target.shouldermobility_l_comments.value,
			"shoulderclearance_r_comments" : mskstate.target.shoulderclearance_r_comments.value,
			"activestraightlegraise_r_rawscore" : mskstate.target.activestraightlegraise_r_rawscore.value,
			"activestraightlegraise_r_finalscore" : mskstate.target.activestraightlegraise_r_finalscore.value,
			"activestraightlegraise_r_comments" : mskstate.target.activestraightlegraise_r_comments.value,
			"activestraightlegraise_l_rawscore" : mskstate.target.activestraightlegraise_l_rawscore.value,
			"activestraightlegraise_l_comments" : mskstate.target.activestraightlegraise_l_comments.value,
			"trunkstabilitypushup_rawscore" : mskstate.target.trunkstabilitypushup_rawscore.value,
			"trunkstabilitypushup_finalscore" : mskstate.target.trunkstabilitypushup_finalscore.value,
			"trunkstabilitypushup_comments" : mskstate.target.trunkstabilitypushup_comments.value,
			"pressupclearing_comments" : mskstate.target.pressupclearing_comments.value,
			"rotarystability_r_rawscore" : mskstate.target.rotarystability_r_rawscore.value,
			"rotarystability_r_finalscore" : mskstate.target.rotarystability_r_finalscore.value,
			"rotarystability_r_comments" : mskstate.target.rotarystability_r_comments.value,
			"rotarystability_l_rawscore" : mskstate.target.rotarystability_l_rawscore.value,
			"rotarystability_l_comments" : mskstate.target.rotarystability_l_comments.value,
			"posteriorrocking_comments" : mskstate.target.posteriorrocking_comments.value,
			"totalscore_finalscore" : mskstate.target.totalscore_finalscore.value,
			"functionalmovement_impression" : mskstate.target.functionalmovement_impression.value,
			"functionalmovement_approach" : mskstate.target.functionalmovement_approach.value,
			"boxjump_score" : mskstate.target.boxjump_score.value,
			"boxjump_remarks" : mskstate.target.boxjump_remarks.value,
			"singlerighthopright_score" : mskstate.target.singlerighthopright_score.value,
			"singlerighthopright_remarks" : mskstate.target.singlerighthopright_remarks.value,
			"singlerighthopleft_score" : mskstate.target.singlerighthopleft_score.value,
			"singlerighthopleft_remarks" : mskstate.target.singlerighthopleft_remarks.value,
			"deadlift_score" : mskstate.target.deadlift_score.value,
			"deadlift_remarks" : mskstate.target.deadlift_remarks.value,
			"pullup_score" : mskstate.target.pullup_score.value,
			"pullup_remarks" : mskstate.target.pullup_remarks.value,
			"pushup_score" : mskstate.target.pushup_score.value,
			"pushup_remarks" : mskstate.target.pushup_remarks.value,
			"plank_score" : mskstate.target.plank_score.value,
			"plank_remarks" : mskstate.target.plank_remarks.value,
			"medicineball_score" : mskstate.target.medicineball_score.value,
			"medicineball_remarks" : mskstate.target.medicineball_remarks.value,
			"movementpattern_impression" : mskstate.target.movementpattern_impression.value,
			"movementpattern_approach" : mskstate.target.movementpattern_approach.value,

			"clubhd_box" : mskstate.target.clubhd_box.value,
			"drivercarry_distance" : mskstate.target.drivercarry_distance.value,
			"clubhd_impression" : mskstate.target.clubhd_impression.value,
			"clubhd_approach" : mskstate.target.clubhd_approach.value,
			"clubhdshrtgoal1" : mskstate.target.clubhdshrtgoal1.value,
			"clubhdlonggoal1" : mskstate.target.clubhdlonggoal1.value,

			"onermtestcheck" : onermtestcheck,
			"aerobicfitnesscheck" : aerobicfitnesscheck,
			"lowerbodypowercheck" : lowerbodypowercheck,
			"upperbodystrengthcheck" : upperbodystrengthcheck,
			"accelerationspeedcheck" : accelerationspeedcheck,
			"coreendurancecheck" : coreendurancecheck,


			"rmclean_value" : rmclean_value,
			"rmclean_remarks" : rmclean_remarks,
			"rmsquat_value" : rmsquat_value,
			"rmsquat_remarks" : rmsquat_remarks,
			"rmpress_value" : rmpress_value,
			"rmpress_remarks" : rmpress_remarks,
			"rmcleanestimate_value":rmcleanestimate_value,
			"rmsquatestimate_value":rmsquatestimate_value,
			"rmpressestimate_value":rmpressestimate_value,
			"rmcleanestimate_rm":rmcleanestimate_rm,
			"rmsquatestimate_rm":rmsquatestimate_rm,
			"rmpressestimate_rm":rmpressestimate_rm,
			"aerobicfitness_time" : aerobicfitness_time,
			"aerobicfitness_vo" : aerobicfitness_vo,
			"aerobicfitness_remarks" : aerobicfitness_remarks,
			"lowerboay_trial1" : lowerboay_trial1,
			"lowerboay_trial2" : lowerboay_trial2,
			"lowerboay_trial3" : lowerboay_trial3,
			"lowerboay_result" : lowerboay_result,
			"lowerboay_remarks" : lowerboay_remarks,
			"upperbodystrength_score" : upperbodystrength_score,
			"upperbodystrength_remarks" : upperbodystrength_remarks,
			"acceleration_trial1" : acceleration_trial1,
			"acceleration_trial2" : acceleration_trial2,
			"acceleration_trial3" : acceleration_trial3,
			"acceleration_remarks" : acceleration_remarks,
			"acceleration_result" : acceleration_result,
			"coreendurance_score" : coreendurance_score,
			"coreendurance_remarks" : coreendurance_remarks
		}
		
		
        dispatch({ type: SCASSESSMENT_ACTION});
        return axios.post(AppConfig.apiurl+'/api/editscassessment', payload, { headers: AuthHeader.header })
            .then( response => {       
                if(response.status==200){ 
                    var resdata=response.data;
                    if(resdata.status===1){
                        allSCAssessment()(dispatch);
                        NotificationManager.success(resdata.message);               
                        dispatch({ type: EDIT_SCASSESSMENT_SUCCESS});
                    }else{
                        NotificationManager.error(resdata.message); 
                        dispatch({ type: EDIT_SCASSESSMENT_FAILURE});			   
                    }	
                        
                }else{
                    NotificationManager.error('SC Assessment not updated');	
                    dispatch({ type: EDIT_SCASSESSMENT_FAILURE});	  
                }  
                
                return Promise.resolve(resdata);
                
            })
            .catch( error => { 
                const errormsg=error.message
                NotificationManager.error(errormsg);
                dispatch({ type: EDIT_SCASSESSMENT_FAILURE});
            });		

}

export const deleteSCAssessment = (scid) => async (dispatch) => {
	
	var payload={
		"id":scid
	}
	
	  dispatch({ type: SCASSESSMENT_ACTION});
		 return axios.post(AppConfig.apiurl+'/api/deleteSCAssessmentData', payload, { headers: AuthHeader.header })
			.then( response => {   
				var resdata=response.data;
				if(resdata.status===1){
					allSCAssessment()(dispatch);
					NotificationManager.success(resdata.message);               
					dispatch({ type: DELETE_SCASSESSMENT_SUCCESS});
				}else{
					NotificationManager.error(resdata.message); 
					dispatch({ type: DELETE_SCASSESSMENT_FAILURE});			   
				}
					
				
			})
			.catch( error => { 
				const errormsg=error.message
				NotificationManager.error(errormsg);
			});

	
}




